import Pagination from "../../../../material/pagination/Pagination";
import PaginationConfig from "../../../../material/pagination/PaginationConfig";
import Operator from "../../../../material/pagination/Operator";
import PaginationColumn from "../../../../material/pagination/PaginationColumn";
import useSecurity from "../../../../use/useSecurity";
import useEntrepreneurRepository from "../../../../repository/user/useEntrepreneurRepository";
import {useEffect} from "react";
import isNull from "../../../../mixin/isNull";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";
import {useNavigate} from "react-router";
import route from "../../../../enum/route";
import Body from "../../../../material/skeleton/Body";
import Type from "../../../../material/pagination/Type";
import Suggestion from "../../../../entity/assignment/Suggestion";

export default function () {
    const security = useSecurity();
    const navigate = useNavigate();
    const entrepreneurRepository = useEntrepreneurRepository();
    /** @type Entrepreneur */
    const entrepreneur = entrepreneurRepository.findOneById(security.id).select();

    useEffect(() => {
        entrepreneurRepository.findOneById(security.id).exec();
    }, []);

    if (isNull(entrepreneur)) {
        return (
            <Box mt={20} display="flex" justifyContent="center">
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <Body hasFooter={false}>
            <Pagination
                paginationConfig={
                    new PaginationConfig()
                        .setId("suggestion-list-v2")
                        .setUri("/service-data-repository/entrepreneur/pagination/assignment/suggestion")
                        .setOnRowClicked(row => navigate(route.ENTREPRENEUR_SUGGESTION.replace(":token", row.suggestion_token)))
                        .setFieldAsId("suggestion_id")
                        .addFixedFilter("company_id", Operator.EQUALS, entrepreneur.getCompanyId())
                        .addFixedFilter("to_attribute", Operator.EQUALS, 1)
                        .addFixedFilter("suggestion_status", Operator.EQUALS, Suggestion.STATUS_PROPOSED)
                        .setHideToolbar(true)
                        .setPerPage(10)
                        .addPaginationColumn(
                            new PaginationColumn()
                                .setHeader("Dossier")
                                .setField("order_id")
                                .setType(Type.NUMBER)
                                .setDisableSearchOption(true)
                                .setDefaultWidth(0.1)
                        )
                        .addPaginationColumn(
                            new PaginationColumn()
                                .setHeader("Ville")
                                .setField("order_address_city")
                                .setDisableSearchOption(true)
                                .setDefaultWidth(0.1)
                        )
                        .addPaginationColumn(
                            new PaginationColumn()
                                .setHeader("Code postal")
                                .setField("order_address_postcode")
                                .setDisableSearchOption(true)
                                .setDefaultWidth(0.1)
                        )
                }
            />
        </Body>
    )
}